import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetSchedules: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_SCHEDULES_COMPLETED, payload: null });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Schedule/OrganizationSchedules/" + store().currentuser.currentorganization.id + "?"
        + "pageNumber=" + pageNumber
        + "&pageSize=" + pageSize
        + (sortExpression ? "&sortExpression=" + sortExpression : "")
        + (filterExpression ? "&filterExpression=" + filterExpression : "")
        + (tagSearchRequest ? tagSearchRequest : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_SCHEDULES_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetSchedule: (id, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Schedule/" + id,
            {
                method: "GET"
            })
            .then((data) => {
                onSuccess(data);
            }).catch( (data) => {
                console.log(data);
            });
    },

    CreateSchedule: (object, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Schedule/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(object),
            method: "POST"
        }).then((data) => {
            toast.success(strings.scheduleSaved);
            if (onSuccess) {onSuccess(data);}
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditSchedule: (object, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Schedule/" + store().currentuser.currentorganization.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(object),
            method: "PUT"
        }).then((data) => {
            toast.success(strings.scheduleSaved);
            if (onSuccess) {onSuccess(data);}
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    DeleteSchedule: (id, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Schedule/" + id, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.scheduleDeleted);
            if (onSuccess) {onSuccess(data);}
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    DuplicateSchedule: (id, name, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Schedule/Duplicate/" + id + (name ? "?name=" + name : ""), {
            method: "GET"
        }).then((data) => {
            toast.success(strings.scheduleDuplicated);
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    }
};
